import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  *, *::before, *::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  // html, body, #root {       
  //   overflow-x: hidden; 
  // }

  body {
    font-family: 'Pretendard', sans-serif;
    font-size: 16px;
    color: ${(props) => props.theme.colors.text.normal};
    overflow-x: hidden;  
  }

  input, textarea, button {
    font-family: inherit;
    font-variant-numeric: inherit;
    font-size: inherit;
    color: inherit;
  }

  a {
    text-decoration: none;
  }
  
  ol, ul {
	  list-style: none;
  }
`;
export default GlobalStyle;
